import request from '@/utils/request'

export function getAdjustableWorkingDateList(data) {
  return request({
    url: '/api/adjustableWorkingDate/list',
    method: 'post',
    data,
  })
}
export function getConstructionWorkingConditionsList(data) {
  return request({
    url: '/api/constructionWorkingConditions/list',
    method: 'post',
    data,
  })
}
export function getscheduleAdjustmentList(data) {
  return request({
    url: '/api/scheduleAdjustment/list',
    method: 'post',
    data,
  })
}

export function getWorkableDailyDetail(data) {
  return request({
    url: '/api/WorkableDaily/detail',
    method: 'post',
    data,
  })
}
